<form [formGroup]="form" class="date-form" (ngSubmit)="updateSearch()">
  <label class="label">{{ label || 'ADMIN.DEVICES.SELECT_DATE' | translate }}:</label>

  <lin-datepicker-field
    formControlName="selected"
    [isRange]="true"
    [isPlaceholderShown]="true"
    [isWithTimePicker]="true"
    (datePickerRangeChange)="onDateRangeChange($event)"
  ></lin-datepicker-field>
  <lin-form-submit-button-upd [isLoading]="isLoading" [isDisabled]="isDisabled">
    {{ 'BUTTONS.SEARCH' | translate }}
  </lin-form-submit-button-upd>
</form>
